var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-icon",class:_vm.$reconava.getStatusClass(_vm.value)},[_c('span',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.$reconava.getStatusName(_vm.value)))])])}
var staticRenderFns = []

export { render, staticRenderFns }